export default {
  general: {
    Start: "Start",
    Back: "Zurück",
    Next: "Weiter",
    Cancel: "Abbrechen",
    Skip: "Überspringen",
    Preview: "Vorschau",
    Email: "Geben Sie Ihre E-Mail-Adresse ein",
    EmailHint: "E-Mail",
    Phone: "Geben Sie Ihre Telefonnummer ein",
    PhoneHint: "Telefonnummer",
    Password: "Geben Sie Ihr Passwort ein",
    PasswordHint: "Passwort",
    PasswordReenter: "Geben Sie Ihr Passwort erneut ein",
    CreatePasswordTitle: "Erstellen Sie ein Passwort, um Ihr Konto zu sichern und einen sicheren Zugang zu gewährleisten.",
    CreatePasswordCheck: "Es sollte mindestens {1}8 Zeichen{2} lang sein, {3}kleine{4} und {5}große{6} Buchstaben, {7}eine Zahl{8} und {9}ein Sonderzeichen{10} enthalten.",
    CreatePasswordMustMatch: "Das Passwort muss übereinstimmen.",
    CreateNewPassword: "Erstellen Sie ein neues Passwort",
    Setup: "Einstellungen",
    Create: "Erstellen",
    RememberMe: "Angemeldet bleiben",
    ForgotPassword: "Passwort vergessen?",
    Login: "Anmelden",
    Logout: "Logout",
    CloseAccount: "Close account",    
    CloseAccountAsk: "Möchten Sie das Konto wirklich schließen?",
    Yes: "Yes",
    No: "No",
    or: "oder",
    Add: "Hinzufügen",
    DontHaveAccount: "Haben Sie kein Konto?",
    Register: "Registrieren",
    Verify: "Bestätigen",
    Send: "Senden",
    TryAgain: "Versuchen Sie es erneut",
    EnterName: "Geben Sie Ihren Vornamen ein",
    EnterNameHint: "Vorname",
    EnterSurname: "Geben Sie Ihren Nachnamen ein",
    EnterSurnameHint: "Nachname",
    Connecting: "Verbinden...",
    Search: "Suchen",
    Generate: "Generieren",
    Finish: "Fertig",
    Save: "Speichern",
    SaveInProgres: "Speichern läuft..."
  },

  bottomPanel: {
    Profile: "Profil",
    Tasks: "Aufgaben",
    Host: "Gastgeber",
    Messages: "Nachrichten",
    Alerts: "Benachrichtigungen"
  },
  
  login: {
    VerificationTitleEmail: "Geben Sie den Verifizierungscode ein, der an Ihre E-Mail gesendet wurde.",
    VerificationTitlePhone: "Geben Sie den Verifizierungscode ein, der an Ihr Telefon gesendet wurde.",
    HaventReceivedCode: "Haben Sie keine E-Mail erhalten?",
    CodeSendPhone: "Der Verifizierungscode wurde an Ihr Telefon gesendet.",
    CodeSendEmail: "Der Verifizierungscode wurde an Ihre E-Mail gesendet.",
    CodeSendFailed: "Der Bestätigungscode kann nicht gesendet werden.",
    CodeSendDisabled: "Bitte warten Sie {1} Sek., bevor Sie den Verifizierungscode erneut anfordern können.",
    CodeWrong: "Falscher Code, versuchen Sie es erneut!",
    EnterFullName: "Bitte geben Sie Ihren vollständigen Namen ein, um Ihr Profil abzuschließen.",
    AgreeTo: "Ich stimme zu",
    TermsConditions: "Allgemeine Geschäftsbedingungen",
    PasswordResetTitle: "Bitte geben Sie die E-Mail-Adresse an, an die der Link zum Zurücksetzen des Passworts gesendet wird.",
    PosswordResetSend: "Die Anweisung zum Zurücksetzen des Passworts wurde an die angegebene E-Mail-Adresse gesendet.",
    PasswordResetNew: "Das neue Passwort wurde festgelegt.",
    CantCreateAccount: "Konto konnte nicht erstellt werden. Bitte versuchen Sie es später noch einmal.",
    CantLogin: "Anmeldung nicht möglich, falsche Anmeldedaten.",
    LoginDeactivated: "Anmeldung nicht möglich, Ihr Konto ist geschlossen. Bitte kontaktieren Sie den Support, um Ihr Konto wieder zu öffnen.",
    PropertiesTitle: "Immobilien",
    PropertiesDescription: "Eine schnelle, bequeme und transparente Möglichkeit, Ihre Immobilie zu präsentieren und die richtigen Kunden anzuziehen.",
    GuestsTitle: "Gäste",
    GuestsDescription: "Ihre vollständige Gästedatenbank, die Ihnen schnellen Zugriff auf vorherige Kontakte ermöglicht. Treten Sie leicht in Kontakt und laden Sie sie erneut ein, mit der gesamten Kommunikations- und Aktivitätshistorie an einem Ort.",
    OffersTitle: "Angebote",
    OffersDesctiption: "Bleiben Sie auf dem Laufenden mit allen gesendeten Mietangeboten, erhalten Sie automatische Erinnerungen, damit nichts übersehen wird, und lenken Sie Ihr Angebot in Richtung einer erfolgreichen Buchung.",
    ReservationsTitle: "Reservierungen",
    ReservationsDescription: "Eine klare und intuitive Möglichkeit, Reservierungen zu verwalten. Wissen Sie genau, wann Ihre Gäste zu Besuch kommen, mit Erinnerungen an Aufgaben, um einen erstklassigen Service zu bieten.",
    MarketingTitle: "Marketing",
    MarketingDescription: "Ein effizientes Tool zur Erstellung von ansprechenden Marketinginhalten auf Facebook und Instagram, unterstützt von künstlicher Intelligenz.",
    FinanceTitle: "Finanzen",
    FinanceDescription: "Ein einfacher, benutzerfreundlicher Überblick über die Finanzen Ihrer Immobilie, einschließlich der Rendite und der Zahlungen der Kunden - alles an einem Ort.",
    StatisticsTitle: "Statistiken",
    StatisticsDescription: "Ein schneller Überblick über die wichtigsten Kennzahlen Ihrer Immobilie, der Ihnen hilft, die Leistung zu verfolgen, und mit Hilfe von KI erhalten Sie Vorschläge, worauf Sie sich als nächstes konzentrieren sollten."
  },

  termsConditions: {
    title: "Allgemeine Geschäftsbedingungen",
    introduction: "Willkommen auf unserer Website! Durch den Zugriff auf unsere Dienste stimmen Sie zu, sich an die folgenden Allgemeinen Geschäftsbedingungen zu halten.",
    useOfWebsite: "Sie stimmen zu, diese Website nur für rechtmäßige Zwecke zu nutzen. Sie dürfen diese Website nicht in einer Weise nutzen, die die Funktionalität der Website beschädigen, deaktivieren oder beeinträchtigen könnte.",
    accountRegistration: "Wenn Sie ein Konto auf unserer Website erstellen, sind Sie verantwortlich für die Wahrung der Vertraulichkeit Ihrer Anmeldedaten und für alle Aktivitäten, die unter Ihrem Konto stattfinden.",
    intellectualProperty: "Alle Inhalte auf dieser Website, einschließlich Texte, Grafiken und Logos, sind Eigentum des Website-Inhabers und durch Urheberrechtsgesetze geschützt.",
    privacyPolicy: "Ihre Privatsphäre ist uns wichtig. Bitte lesen Sie unsere Datenschutzrichtlinie, um zu erfahren, wie wir Ihre persönlichen Daten verarbeiten.",
    limitationOfLiability: "Wir haften nicht für Schäden oder Verluste, die durch die Nutzung der Website entstehen. Sie nutzen die Website auf eigenes Risiko.",
    modifications: "Wir behalten uns das Recht vor, diese Allgemeinen Geschäftsbedingungen jederzeit zu ändern. Änderungen werden auf dieser Seite veröffentlicht, und es liegt in Ihrer Verantwortung, diese regelmäßig zu überprüfen.",
    governingLaw: "Diese Allgemeinen Geschäftsbedingungen unterliegen dem Recht der Gerichtsbarkeit, in der sich der Website-Inhaber befindet. Alle Streitigkeiten werden vor den zuständigen Gerichten dieser Gerichtsbarkeit verhandelt.",
    contactUs: "Wenn Sie Fragen oder Bedenken zu diesen Allgemeinen Geschäftsbedingungen haben, kontaktieren Sie uns bitte."
  },

  host: {
    Properties: "Immobilien",
    PropertyDescribe: "Beschreiben Sie die Immobilie",
    Guests: "Gäste",
    GuestAdd: "Gast hinzufügen",
    Places: "Orte",
    PlaceDescribe: "Beschreiben Sie den Ort",
    PlaceAI: "Geben Sie einige Details zum Ort ein, den Sie hinzufügen möchten, um ihn automatisch zu generieren.",
    Attractions: "Attraktionen",
    AttractionDescribe: "Beschreiben Sie die Attraktion",
    AttractionAI: "Geben Sie die Details der Attraktion ein, die Sie hinzufügen möchten, um sie automatisch zu generieren.",
    Dishes: "Gerichte",
    DisheDescribe: "Beschreiben Sie das Gericht",
    Restaurants: "Restaurants",
    RestaurantDescribe: "Beschreiben Sie das Restaurant",
    Offers: "Angebote",
    OfferAdd: "Angebot hinzufügen",
    Reservations: "Reservierungen",
    ReservationAdd: "Reservierung hinzufügen",
    Marketing: "Marketing",
    Statistics: "Statistiken",
    Finance: "Finanzen",
    Calendar: "Kalender",
    Overview: "Übersicht",
    Gallery: "Galerie",
    AttractionOverview: "Übersicht der Attraktionen",
    PlaceOverview: "Übersicht des Ortes",
    DishOverview: "Übersicht des Gerichts",
    RestaurantOverview: "Übersicht des Restaurants",
    AddFailed: "Beim Hinzufügen ist ein Fehler aufgetreten.",
    UpdateFailed: "Beim Speichern ist ein Fehler aufgetreten.",
    AddOk: "Erfolgreich hinzugefügt.",
    UpdateOk: "Erfolgreich gespeichert.",
    UniqueIdExists: "Die eindeutige ID wurde bereits verwendet. Bitte wählen Sie eine andere aus.",
    ListEmpty: "Die Liste ist leer, füge das erste Element hinzu.",
    ListCantLoadItem: "Kann das Element nicht laden!",
    ListCancelAsk: "Bist du sicher, dass du die vorgenommenen Änderungen verlieren möchtest?",
    DeleteItemAsk: "Möchten Sie dieses Element wirklich löschen?",
    DeleteItemOk: "Element gelöscht.",
    DeleteItemFailed: "Kann das Element nicht löschen!"
  },

  edit: {
    Name: "Name",
    NameHint: "Geben Sie den Namen ein",
    Slogan: "Slogan",
    SloganHint: "Geben Sie den Slogan ein",
    PhotoAdd: "Fotos hinzufügen",
    PhotoSelect: "Galerie ist leer",
    PhotoChangeOrder: "Halten Sie die Fotos gedrückt und bewegen Sie sie, um die Reihenfolge zu ändern. Das erste Foto wird das Miniaturbild sein.",
    Description: "Beschreibung",
    DescriptionAdd: "Beschreibung hinzufügen",
    AttractionsAdd: "Attraktionen hinzufügen",
    RestaurantsAdd: "Restaurants hinzufügen",
    FactsAdd: "Interessante Fakten hinzufügen",
    DetailsAdd: "Details hinzufügen",
    DishesAdd: "Gerichte hinzufügen",
    VisitTime: "Besuchszeit",
    VisitTimeHint: "Geben Sie die Besuchszeit ein",
    TicketsBuy: "Wo Tickets kaufen",
    TicketsBuyHint: "Geben Sie ein, wo Tickets gekauft werden können",
    Website: "Webseite",
    WebsiteHint: "Geben Sie die Webseite ein",
    Place: "Ort",
    PlaceHint: "Wählen Sie einen Ort",
    Address: "Adresse",
    AddressHint: "Geben Sie die Adresse ein",
    MoreInformations: "Weitere Informationen",
    MoreInformationsHint: "Geben Sie mehr Informationen ein",
    UniqueId: "Eindeutige ID",
    UniqueIdHint: "Geben Sie eine eindeutige ID ein (a-z 0-9 _)"
  },

  language: {
    Polish: "Polnisch",
    English: "Englisch",
    German: "Deutsch",
    Spanish: "Spanisch",
    AITranslate: "KI übersetzen"
  },

  ai: {
    translationNotAvailable: "KI-Übersetzung ist derzeit nicht verfügbar.",
    serviceNotAvailable: "KI-Dienst ist nicht verfügbar."
  },

  addressPopup: {
    copyAddress: "📋 Adresse kopieren",
    copyGPS: "📍 GPS-Koordinaten kopieren",
    openMaps: "🗺 In Karten öffnen"
  },

  state: {
    placeNew: "Neu",
    placeInPreparation: "In Vorbereitung",
    placePublished: "Veröffentlicht"
  },

  waitingList: {
    Sign: "Anmelden",
    AlreadyExists: "Sie sind bereits auf der Warteliste.",
    Added: "Sie wurden zur Warteliste hinzugefügt, vielen Dank für Ihr Interesse an unserer App!!",
    Title: "Melden Sie sich auf der Warteliste an",
    Agreement: "Mit der Anmeldung stimmen Sie zu, Informationen zur Flatlinker-App an die angegebene E-Mail-Adresse zu erhalten. Sie können sich von den erhaltenen Informationen abmelden, indem Sie eine E-Mail an newsletter@flatlinker.com senden mit dem Inhalt: Abmelden von der Liste."
  }
};